import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=14963af4&lang=pug&"
import script from "./Appointments.vue?vue&type=script&lang=ts&"
export * from "./Appointments.vue?vue&type=script&lang=ts&"
import style0 from "./Appointments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports